import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'
import lang from '@/lang'

const TimetrackingList = React.lazy(() => import('@/modules/timetracking/components/list/timetracking-list'))
const TimetrackingEdit = React.lazy(() => import('@/modules/timetracking/components/edit/timetracking-edit'))
const TimetrackingBillingView = React.lazy(() => import('@/modules/timetracking/components/billing/timetracking-billing-view'))

const timetrackingRoutes = (
  <>
    <Route path='timetracking/*' element={<RedirectToPlural />} />
    <Route path='timetrackings' Component={TimetrackingList} handle={{ title: lang.timeTrackingTitle, options: { noBackgroundColor: true } }} />

    <Route path='timetrackings/new' Component={TimetrackingEdit} />
    <Route path='timetrackings/new/customer/:customerId' Component={TimetrackingEdit} />
    <Route path='timetrackings/edit/:id' Component={TimetrackingEdit} />
    <Route path='timetrackings/billing/customer/:id/:hash?' Component={TimetrackingBillingView} />
  </>
)

export default timetrackingRoutes
